import { Button, IconButton } from "@mui/material";
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import { FavouritesContext, IFavouritesFolder } from "./favouritesProvider";
import EditIcon from '@mui/icons-material/Edit';

interface EditFolderButtonProps {
    folder: IFavouritesFolder;
}

export const EditFolderButton = (props: EditFolderButtonProps) => {
    const { showEditFolderModal } = useContextWithGuard(FavouritesContext, "AlbumContext");

    return (
        <IconButton
            size="large"
            edge="start"
            aria-label="Edit folder"
            sx={{
                mr: 2,
                border: 'none !important',

            }}
            aria-haspopup="true"
            onClick={() => {
                if (props.folder) {
                    showEditFolderModal(props.folder);
                }
            }}
            title="edit folder"
            color="primary"
        >
            <EditIcon />
        </IconButton>
    )

}